import { useStyletron } from 'parkdepot-shared/theme'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

// style component
import FlexContainer from '../../../../components/style/FlexContainer.style'
import Icon from '../../../../components/style/Icon.style'
import Text from '../../../../components/style/Text.style'
import {
    SectionWrapper,
    InformationTitle,
    LotAddress,
    SectionTitle,
    Container,
    Description
} from './AdditionalInformation.style'

// types
import { ActiveFeature, Prices } from '../../../../types/lot.interface'

// components
import LotPrices from '../LotPrices/LotPrices.component'
import OpeningHoursSection from '../OpeningHoursSection/OpeningHoursSection.component'
import { OpeningHoursRrules } from 'parkdepot-shared/gql/graphql'

interface Props {
    lotId: string
    address: string
    city: string
    description?: string
    prices?: Prices[]
    showDiscount: boolean
    minBookingDurationInDays: number
    maxBookingDurationInDays: number
    openingHours: OpeningHoursRrules[]
    enabledFeatures?: ActiveFeature[]
}

const AdditionalInformation: FC<Props> = ({
    lotId,
    address,
    city,
    description,
    prices,
    showDiscount,
    minBookingDurationInDays,
    maxBookingDurationInDays,
    openingHours,
    enabledFeatures
}) => {
    const { t } = useTranslation()
    const [css, theme] = useStyletron()

    return (
        <>
            <InformationTitle>{t('lot.additionalInformation')}</InformationTitle>
            <Container>
                {showDiscount && (
                    <Text typography={theme.typography} color="#6FC59E" marginbottom="12px" $fontsize="16px">
                        <span>{t('bookings.reducedPriceIncluded')}</span>
                    </Text>
                )}
                <OpeningHoursSection openingHours={openingHours} />

                {/* prices */}
                {prices && (
                    <LotPrices
                        lotId={lotId}
                        prices={prices}
                        enabledFeatures={enabledFeatures || []}
                        minBookingDurationInDays={minBookingDurationInDays}
                        maxBookingDurationInDays={maxBookingDurationInDays}
                    />
                )}

                {/* address */}
                <SectionWrapper>
                    <div
                        className={css({
                            marginTop: '5px'
                        })}
                    >
                        <Icon className="wemolo-location-2" color={theme.colors.primary} aria-hidden="true" />
                    </div>
                    <div>
                        <SectionTitle>{t('common.address')}</SectionTitle>
                        <LotAddress>{address}</LotAddress>
                        <LotAddress>{city}</LotAddress>
                    </div>
                </SectionWrapper>
                <SectionWrapper>
                    <div
                        className={css({
                            marginTop: '5px'
                        })}
                    >
                        <Icon className="wemolo-parking-house" color={theme.colors.primary} aria-hidden="true" />
                    </div>
                    <div
                        className={css({
                            display: 'flex',
                            flexDirection: 'column'
                        })}
                    >
                        <SectionTitle>{t('lot.description')}</SectionTitle>
                        <Description dangerouslySetInnerHTML={{ __html: description || '' }} />
                    </div>
                </SectionWrapper>
            </Container>
        </>
    )
}

export default React.memo(AdditionalInformation)
